var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDoubleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29289 17.7071C3.90237 17.3166 3.90237 16.6834 4.29289 16.2929L9.18579 11.4L4.29289 6.50711C3.90237 6.11658 3.90237 5.48342 4.29289 5.09289C4.68342 4.70237 5.31658 4.70237 5.70711 5.09289L11.3071 10.6929C11.4946 10.8804 11.6 11.1348 11.6 11.4C11.6 11.6652 11.4946 11.9196 11.3071 12.1071L5.70711 17.7071C5.31658 18.0976 4.68342 18.0976 4.29289 17.7071ZM12.6929 17.7071C12.3024 17.3166 12.3024 16.6834 12.6929 16.2929L17.5858 11.4L12.6929 6.50711C12.3024 6.11658 12.3024 5.48342 12.6929 5.09289C13.0834 4.70237 13.7166 4.70237 14.1071 5.09289L19.7071 10.6929C20.0976 11.0834 20.0976 11.7166 19.7071 12.1071L14.1071 17.7071C13.7166 18.0976 13.0834 18.0976 12.6929 17.7071Z",
    fill: "#101728"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDoubleRight);
export default __webpack_public_path__ + "static/media/ic-double-right.21502fa60ef1b08b4805755a86921c44.svg";
export { ForwardRef as ReactComponent };